// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationNewBusinessPath = 'M75.4 23.045V23h-7a7.4 7.4 0 01-14.8 0h-7a7.2 7.2 0 01-7.4 6.9 7.2 7.2 0 01-7.4-6.9h-7v.1a7.2 7.2 0 01-7.4 6.9 7.2 7.2 0 01-7.3-6.2L16.8 11H85l5.1 12.7a7.4 7.4 0 01-14.7-.6v-.055zm-3.548 9.04A14.17 14.17 0 0082.8 37c.268 0 .535-.007.8-.022V78h-14V48h-38v30h-14V37.002a14.17 14.17 0 0010.748-4.916A14.607 14.607 0 0039.2 36.9c4.336 0 8.25-1.898 10.9-4.867A14.606 14.606 0 0061 36.9c4.31 0 8.204-1.875 10.852-4.814zM97.2 23.1c0 4.843-2.64 9.16-6.6 11.652V85h-28V55h-24v30h-28V35.328C6.09 32.963 3 28.341 3 23.1v-.9L12.6 4h77.1l7.5 18.4v.7zM31.3 92.5l3.4 6.2 6.3-3.5c3.51-1.886 6.908-4.128 9.35-7.3 2.46 3.386 5.995 5.736 9.65 7.7l6.3 3.5 3.4-6.2-6.3-3.4c-7-3.8-9.4-7-9.4-12.6v-5.4h5.9L50.5 60l-9.4 11.5H47v5c0 5.6-2.4 8.8-9.4 12.6l-6.3 3.4z';
var IllustrationNewBusiness = baseIllustration('IllustrationNewBusiness', {
  getPath: () => IllustrationNewBusinessPath
}, 'ColoredIllustrationNewBusiness');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationNewBusiness;
//# sourceMappingURL=index.js.map